<section *ngIf="dataDifferencial">
<app-banner-internal [title]="dataDifferencial.page_title"></app-banner-internal>
<app-carousel-differential [data]="dataDifferencial" [selectedDifferential]="differential"></app-carousel-differential>
</section>
